const HisClipboardList = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style = {_sx} width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.3045 3.43945H15.3358C14.4182 3.43945 13.6743 4.18331 13.6743 5.10091V8.42383C13.6743 9.34143 14.4182 10.0853 15.3358 10.0853H25.3045C26.2221 10.0853 26.966 9.34143 26.966 8.42383V5.10091C26.966 4.18331 26.2221 3.43945 25.3045 3.43945Z"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9663 6.76367H30.2892C31.1705 6.76367 32.0157 7.11376 32.6389 7.73693C33.262 8.3601 33.6121 9.2053 33.6121 10.0866V33.347C33.6121 34.2283 33.262 35.0735 32.6389 35.6967C32.0157 36.3198 31.1705 36.6699 30.2892 36.6699H10.3517C9.47043 36.6699 8.62524 36.3198 8.00207 35.6967C7.3789 35.0735 7.02881 34.2283 7.02881 33.347V10.0866C7.02881 9.2053 7.3789 8.3601 8.00207 7.73693C8.62524 7.11376 9.47043 6.76367 10.3517 6.76367H13.6746"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3203 18.3926H26.9661"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3203 26.7012H26.9661"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6743 18.3926H13.6909"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6743 26.7012H13.6909"
        stroke={strokeColor}
        strokeWidth="3.32292"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisClipboardList;
